import React, { Component } from "react";

class Session extends Component {
  state = {
    hover: false
  };

  render() {
    let getText = this.props.link ? "GET" : "NO LINK";

    const classes = ["session"];
    if (this.state.hover) {
      classes.push("session--hover");
      if (!this.props.link) {
        classes.push("session--nolink");
      }
    }

    return (
      <a
        target="_blank"
        className={classes.join(" ")}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        href={this.props.link}
      >
        {this.state.hover ? getText : this.props.time}
      </a>
    );
  }
}

export default Session;



// WEBPACK FOOTER //
// ./src/components/Session.js